module.exports = __webpack_public_path__ + "static/media/404.d7165a7c.png";